import { useCallback } from 'react';
import {
  selectAuthenticationStatus,
  useDispatch,
  useSelector,
} from '@bonanza-social/toolkit/state';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { Promotion } from '../state/promos/promos.types';
import { launchGame } from '@bonanza-social/games/state';
import { Toast } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';

const usePromoClick = (promo: Promotion) => {
  const dispatch = useDispatch();
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const authStatus = useSelector(selectAuthenticationStatus);
  const [t] = useTranslation('promos');

  const idForNavigate = promo.cta?.categoryId;
  const customUrlForNavigate = promo.cta?.customUrl;

  const onClick = useCallback(() => {
    if (promo.promoType === 'Cashback' && !promo.isOptedIn) {
      Toast.show({
        type: 'success',
        text: t('cashbackOptInToastMessage'),
      });
    }

    if (authStatus === 'unauthenticated') {
      navigation.navigate('RegistrationScreen');
    } else if ('contentType' in promo && promo.contentType === 'Referrer') {
      navigation.navigate('PromoDetails', {
        id: promo.slug,
      });
    } else if (promo.cta?.type === 'LaunchGame' && promo.cta?.gameId) {
      dispatch(launchGame({ id: promo.cta?.gameId }));
    } else if (promo.cta?.type === 'NavigationLobby') {
      navigation.navigate('MainTabNavigator', { screen: 'Games' });
    } else if (promo.cta?.type === 'NavigationPromotions') {
      if (promo.promoType === 'InPeriod') {
        navigation.navigate('Quests');
      } else {
        navigation.navigate('Promos');
      }
    } else if (promo.cta?.type === 'NavigationRegister') {
      navigation.navigate('RegistrationScreen');
    } else if (promo.cta?.type === 'NavigationRewards') {
      navigation.navigate('Rewards');
    } else if (promo.cta?.type === 'NavigationReferral') {
      navigation.navigate('Account');
    } else if (promo.cta?.type === 'NavigateCategory') {
      navigation.navigate('CategoryDetailsScreen', { id: idForNavigate });
    } else if (promo.promotionId) {
      if (promo.promoType === 'InPeriod') {
        navigation.navigate('QuestDetails', {
          path: `/quests/${promo.promotionId}`,
        });
      } else if (customUrlForNavigate) {
        if (typeof window !== 'undefined') {
          window.location.href = customUrlForNavigate;
        }
      } else {
        navigation.navigate('PromoDetails', {
          id: promo.promotionId,
        });
      }
    }
  }, [
    promo,
    dispatch,
    navigation,
    authStatus,
    idForNavigate,
    customUrlForNavigate,
    t,
  ]);

  return onClick;
};

export default usePromoClick;
